import type {SVGProps} from 'react';

export const ReplyOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path d='M8.5 8.1V10.1L10.4 10.2C13.1 10.3 15.3 11.4 17.1 13.5C15 12.8 12.8 12.7 10.4 12.7H8.4V14.7V15.4L4.7 11.7L8.5 8.1ZM10.3 4C10.2 4 10 4 9.8 4.1L2.1 11.3C2 11.4 2 11.5 2 11.7C2 11.8 2 11.9 2.1 12L9.8 19.4C9.9 19.5 10.1 19.5 10.2 19.5C10.3 19.4 10.4 19.3 10.4 19V14.6C15.1 14.6 18.7 15.1 21.2 19.7C21.3 19.8 21.4 19.9 21.5 19.9H21.6C21.8 19.8 21.9 19.6 21.8 19.4C21.9 19.1 21.5 16.4 19.7 13.6C17.5 10.1 14.3 8.2 10.4 8V4.3C10.5 4.1 10.4 4 10.3 4Z' />
    </svg>
);

